import { Outlet } from 'react-router-dom';
import { useFetch } from '../hooks/useFetch';
import { useAuth } from '../hooks/useAuth';
import { settingsApi } from '../api/contentApi';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { AnalyticsScripts } from '../components/layout/AnalyticsScripts';
import { CookieConsent } from '../components/layout/CookieConsent';
import { RappelFloatingCta } from '../components/forms/RappelFloatingCta';
import { MaintenancePage } from '../pages/public/MaintenancePage';
import { GlobalLoader } from '../components/layout/GlobalLoader';
import './PublicLayout.css';

export function PublicLayout() {
  const { data: settings, loading: settingsLoading } = useFetch(() => settingsApi.public(), []);
  const { user, loading: authLoading } = useAuth();

  const maintenanceActif = settings?.['maintenance.actif'] === '1';

  // Le temps de savoir si le mode maintenance est actif et si un back-office est
  // connecté, on affiche l'écran de chargement global plutôt qu'un flash du site
  // public ou du message de maintenance.
  if (settingsLoading || authLoading) return <GlobalLoader />;

  if (maintenanceActif && !user) {
    return <MaintenancePage message={settings?.['maintenance.message']} />;
  }

  return (
    <div className="public-layout">
      <AnalyticsScripts />
      <Header />
      <main className="public-layout__main">
        <Outlet />
      </main>
      <Footer />
      <RappelFloatingCta />
      <CookieConsent />
    </div>
  );
}
